import { Text } from 'platform-components';
import React from 'react';

import './certificate-modal__description.scss';

interface Props {
    descriptionId: string;
}
export const CertificateModalDescription = ({ descriptionId }: Props) => (
    <div className="certificate-modal__description">
        <Text id={descriptionId} size={Text.SIZE.XL} type={Text.TYPE.MARKDOWN} />
    </div>
);
